import React, { Fragment,useState } from "react";
import "./index.scss";
import Label from "lib/Label";
import DynamicForm from "components/DynamicForm";
import { Row, Container } from "react-bootstrap"
import { Image } from "lib";
import show_password from "assets/images/show_password.svg";
import hide_password from "assets/images/hide_password.svg";

// import { useSelector } from "react-redux";

const RecursiveViewCard = (props) => {
  const {
    is_recursive,
    selectedData,
    title,
    form_field_items,
    input_fields,
    custom_styles,
  } = props;

  const isRecursive = (is_recursive && eval(is_recursive)) || false;
  const array = (isRecursive && selectedData?.[form_field_items]) || [];
  const [maskType,setMaskType] = useState({})



  const shouldShowField = (show, data) => {
    if (show) {
      return !!eval(show);
    }
    return true;
  };
  const getMaskedLength = (data) => {
    data = String(data)
    return new Array(data.length).fill("*").join("")
  }

  const IndirectEval = (item) => {
    return eval(item);
  };

  return (
    <>
      {title && title.length ? (
        <Label label={title} className="view_card_label" />
      ) : (
        ""
      )}
      {array?.length > 0 &&
        array?.map((data, i) => (
          <Container fluid className={`.view_card_container mt-1 ${custom_styles}`} key={i}>
           <Row className="p-3 recursive_card"> 
           {input_fields.map((item, index) => {
              const {
                label,
                name,
                size,
                recursive_label,
                show,
                content,
                shouldJoinArray,
                masking_type
              } = item;
              return (
                <Fragment key={index}>
                  {item?.type ? (
                    <Fragment>
                      <DynamicForm
                        formFields={item}
                        selectedData={selectedData}
                        recursive_section={is_recursive}
                        recursive_Data = {data}

                      />
                    </Fragment>
                  ) : (
                    <>
                      {shouldShowField(show, data) && data?.[item.name] ? (
                        <div
                          className={`preview_card gy-3 ${size}`}
                        >
                          <Label
                            label={
                              recursive_label ? data?.[recursive_label] : label
                            }
                            className=".preview_card_label mb-0 fs-15px"
                          />
                          {/* <label className="preview_data_value">{data?.[content]}</label> */}
                          {
                              IndirectEval(data?.[content]) ?(
                                  <div
                                className="table table-responsive"
                                dangerouslySetInnerHTML={{
                                  __html: IndirectEval(data?.[content]),
                                }}
                              />) : (<></>)
                            }

                        <p className="preview_data_value mb-0 fw-bold fs-14px">
                          {shouldJoinArray && Array.isArray(data?.[name]) && data?.[name]?.length > 0
                            ? data?.[name]
                                .map((item) => (item?.label || item?.value ? item?.label || item?.value : item))
                                ?.join(", ")
                            : masking_type === "password" ? (
                              <div className="d-flex align-items-center">
                                {maskType[name + data._id] 
                                  ? data?.[name] 
                                  : getMaskedLength(data?.[name])}
                                <Image
                                  className="mx-2 mb-2"
                                  imageSrc={maskType[name + data._id] ? hide_password : show_password}
                                  onClick={() => {
                                    setMaskType((prev) => ({ ...prev, [name + data._id]: !prev[name + data._id] }));
                                  }}
                                />
                              </div>
                            ) : (
                              data?.[name]
                            )}
                        </p>

                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </Fragment>
              );
            })}
           </Row>
          </Container>
        ))}
    </>
  );
};

export default RecursiveViewCard;
